module.exports = __webpack_public_path__ + "img/bulgaria.65cf79db.png";